export default __webpack_public_path__ + "media/color/ost-2e593081.svg";